export const IS_DEV = process.env.NODE_ENV === 'development';
export const PUBLIC_PATH = process.env.REACT_APP_PUBLIC_PATH;
export const LPCO_SERVER = process.env.REACT_APP_API_URL;
export const LPCO_ADMIN_SERVER = process.env.REACT_APP_ADMIN_API_URL;
export const RIMM_SERVER = process.env.REACT_APP_RIMM_API_URL;
export const MENU_PROVIDER_SERVICE_URL = process.env.REACT_APP_MENU_PROVIDER_SERVICE_URL;
export const DEFAULT_LANGUAGE = process.env.REACT_APP_DEFAULT_LANGUAGE;
export const COUNTRY = process.env.REACT_APP_COUNTRY;
export const SUPPORTED_LANGUAGES = process.env.REACT_APP_SUPPORTED_LANGUAGES;
export const SONALI_PAYMENT_URL = process.env.REACT_APP_SONALI_PAYMENT_URL;
export const TRADE_PORTAL_URL = process.env.REACT_APP_TRADE_PORTAL_URL;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const SENTRY_ENVIRONMENT = process.env.REACT_APP_SENTRY_ENVIRONMENT;
export const SENTRY_TRACES_SAMPLE_RATE = Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE);
export const SENTRY_COMPONENT_PERFORMANCE_MONITORING_IS_ENABLED =
  String(process.env.REACT_APP_SENTRY_COMPONENT_PERFORMANCE_MONITORING_IS_ENABLED) === 'true';
export const SEPARATE_EPHYTO = String(process.env.REACT_APP_SEPARATE_EPHYTO) === 'true';
